import { render, staticRenderFns } from "./ChatGroupCard.vue?vue&type=template&id=a39d0a76&scoped=true"
import script from "./ChatGroupCard.vue?vue&type=script&lang=js"
export * from "./ChatGroupCard.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupCard.vue?vue&type=style&index=0&id=a39d0a76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39d0a76",
  null
  
)

export default component.exports